export default "__VITE_ASSET__2hbMvxXw__"